<template lang="pug">
  div
    .filters(v-if="isAdmin && (customTypes.length || showDeleted)")
      v-switch(
        :label="$t('base.show_deleted')"
        v-model="showDeleted")
    
    table.table.table--bars(v-if="customTypes.length")
      thead
        tr.table__row.table__row--head
          th.table__cell {{ 'base.animal_type' | translate }}
          th.table__cell {{ 'base.animal_count' | translate }}
          th.table__cell
      v-table-body(
        :cols="3"
        :empty="false"
        :loading="!loaded")
        tr.table__row(
          v-for="item in customTypes"
          :key="'custom-' + item.id"
          :class="{ 'table__row--deleted': item.deleted }")
          td.table__cell 
            span {{ item.name | shortstr }}
            .type-badge.type-badge--deleted(v-if="item.deleted") {{ 'base.deleted' | translate }}
          td.table__cell {{ getAnimalCount(item) }}
          td.table__cell.table__cell--action
            v-btn(
              v-if="allowEdit && userType !== 'employee' && !item.deleted"
              icon
              @click="selectAnimalType(item.id)")
              v-icon(
                font-size="1"
                icon="cog")
    
    ui-pagination(
      v-if="showPagination"
      v-model="page"
      :page-count="pageCount"
      @page-change="pageChangeHandler")
    
    .empty-state(v-if="loaded && !hasTypes")
      p {{ 'base.no_animal_types' | translate }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import paginationMixin from '@/mixins/pagination.mixin'
import api from '@/api'
import UiPagination from '@/components/ui/ui-pagination/UiPagination.vue'

export default {
  name: 'TypesTable',

  mixins: [paginationMixin],

  components: {
    UiPagination
  },

  data: () => ({
    userType: null,
    loaded: false,
    showDeleted: false
  }),

  async created () {
    try {
      const { data } = await api.account.get()
      this.userType = data.user_type
    } catch (error) {
      console.error('Failed to fetch user type:', error)
      this.userType = null
    }
  },

  async mounted () {
    const params = this.getParams()
    await this.setupPagination(api.animaltypes.list, params)

    this.loaded = true
  },

  computed: {
    ...mapGetters('animaltypes', [
      'animalTypes',
      'count'
    ]),

    customTypes () {
      return this.items || []
    },

    hasTypes () {
      return this.customTypes.length > 0
    },

    allowEdit () {
      return this.hasPermission('animal_type', 'change')
    },

    allowView () {
      return this.hasPermission('animal_type', 'view')
    }
  },

  watch: {
    async showDeleted () {
      this.loaded = false
      const params = this.getParams()
      await this.setupPagination(api.animaltypes.list, params)
      this.loaded = true
    }
  },

  methods: {
    ...mapActions('animaltypes', [
      'loadAnimalTypes',
      'selectAnimalType'
    ]),

    getParams (page = null) {
      const params = {
        deleted: this.showDeleted
      }

      if (this.$route.params.farm_id) {
        params.farm = this.$route.params.farm_id
      }

      if (page || this.page > 1) {
        params.page = page || this.page
      }

      return params
    },

    getAnimalCount (item) {
      return item.animal_count !== null && item.animal_count !== undefined
        ? item.animal_count
        : 0
    },

    async loadDataList () {
      await this.loadAnimalTypes(this.getParams())
      this.loaded = true
    },

    async updateData () {
      await this.loadAnimalTypes(this.getParams())
      await this.setupPagination(api.animaltypes.list, this.getParams())
      this.loaded = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/abstracts/_variables.scss';

.table-controls {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1.5rem;
  padding: 1rem 0;
  max-width: 200px;
  margin-left: auto;
}

.table__cell:not(:last-child) {
  width: 50%;
}

.table__row--deleted {
  background: #ffebee;
  opacity: 0.7;
  
  .table__cell {
    color: #c62828;
  }
}

.type-badge {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  vertical-align: middle;

  &--deleted {
    background: #c62828;
    color: #fff;
    margin-left: 4px;
  }
}

.empty-state {
  padding: 40px;
  text-align: center;
  color: #999;
}
.filters {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1.5rem;
  
  ::v-deep .v-switch {
    &__label {
      font-size: 1.4rem;
      font-weight: 500;
      color: #666;
    }
  }
}
</style>